import { createFileRoute } from "@tanstack/react-router";
import UnsubscribePage from "@/site/pages/unsubscribe";

/**
 * `?token=` is the whole contract — a per-address unsubscribe capability from an email footer.
 * `?legacy=expired` is where the server sends a pre-cutover legacy `?t=&e=` link it could not
 * resolve (server/routes/public/unsubscribe-compat.ts — TEMPORARY until 2027-10-20).
 */
type UnsubscribeSearch = { token?: string; legacy?: "expired" };

export const Route = createFileRoute("/unsubscribe")({
  component: UnsubscribePage,
  // Typed + validated here rather than read off `window.location.search` in the
  // page, so the token survives a client-side navigation and arrives as a string.
  validateSearch: (search: Record<string, unknown>): UnsubscribeSearch => ({
    token: typeof search.token === "string" && search.token ? search.token : undefined,
    legacy: search.legacy === "expired" ? "expired" : undefined,
  }),
});
